import { getLocale } from '../i18n';

const locale = () => getLocale().replaceAll('_', '-');
export const formatDate = (
  value: Date | string,
  options: Intl.DateTimeFormatOptions = { dateStyle: 'medium' }
) =>
  new Intl.DateTimeFormat(locale(), options).format(
    typeof value === 'string' ? new Date(value) : value
  );
export const formatNumber = (
  value: number,
  options?: Intl.NumberFormatOptions
) => new Intl.NumberFormat(locale(), options).format(value);

export function formatDistance(
  value: Date,
  baseDate = new Date(),
  language = getLocale()
) {
  const seconds = (value.getTime() - baseDate.getTime()) / 1000;
  const units: [Intl.RelativeTimeFormatUnit, number][] = [
    ['year', 31536000],
    ['month', 2592000],
    ['day', 86400],
    ['hour', 3600],
    ['minute', 60],
    ['second', 1]
  ];
  const [unit, divisor] =
    units.find(([, size]) => Math.abs(seconds) >= size) ??
    units[units.length - 1];
  return new Intl.RelativeTimeFormat(language.replaceAll('_', '-')).format(
    Math.round(seconds / divisor),
    unit
  );
}
